// Generated by scripts/build-sprite.mjs - do not edit manually
export const spriteUrl = '/sprite.c24bbf86e0f4.svg' as const;

export type IconName =
  | '7days'
  | 'adaptive-cruise-control'
  | 'air-conditioning'
  | 'alloy-wheel'
  | 'ancap'
  | 'android-auto'
  | 'apple-car-play'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up'
  | 'automatic-transmission'
  | 'avatar'
  | 'awd'
  | 'battery-capacity'
  | 'bell-off'
  | 'bell-on'
  | 'bin'
  | 'body-type'
  | 'calendar'
  | 'calendar-with-tick'
  | 'call'
  | 'car-finance-application'
  | 'car-front'
  | 'caret-down'
  | 'caret-left'
  | 'caret-right'
  | 'caret-right-filters'
  | 'caret-up'
  | 'check'
  | 'circle-cross-filled'
  | 'circle-tick-filled'
  | 'clock'
  | 'close'
  | 'close-doors'
  | 'colour'
  | 'coupon'
  | 'cylinders'
  | 'delivery-car'
  | 'direction-gps'
  | 'document'
  | 'door'
  | 'download'
  | 'drive-type'
  | 'edit'
  | 'electric-motor'
  | 'electric-range'
  | 'email'
  | 'emissions'
  | 'energy-consumption'
  | 'engine'
  | 'engine-power'
  | 'expand'
  | 'exterior'
  | 'features'
  | 'file'
  | 'filter'
  | 'form'
  | 'free-delivery'
  | 'fuel-consumption'
  | 'fuel-tank-capacity'
  | 'gallery'
  | 'heads-up-display'
  | 'headset'
  | 'heart'
  | 'heart-filled'
  | 'heated-seat'
  | 'hide'
  | 'image'
  | 'imperfections'
  | 'info-circle'
  | 'info-circle-empty'
  | 'interior'
  | 'keyless-entry'
  | 'length'
  | 'location-pin'
  | 'make-model'
  | 'manual-transmission'
  | 'mechanical'
  | 'menu'
  | 'message'
  | 'meter'
  | 'number-of-keys'
  | 'open-bonnet'
  | 'open-doors'
  | 'pdf'
  | 'pencil'
  | 'petrol'
  | 'phone'
  | 'play'
  | 'price'
  | 'push-start'
  | 'question-mark-empty'
  | 'rear-parking-camera'
  | 'rear-parking-sensor'
  | 'registration-number'
  | 'safety'
  | 'search'
  | 'seats'
  | 'share'
  | 'show'
  | 'sign-out'
  | 'sort'
  | 'spanner'
  | 'sparkle'
  | 'sunroof'
  | 'thumbs-up'
  | 'tick'
  | 'tow-cap-braked'
  | 'towing'
  | 'transparent-rates'
  | 'trash'
  | 'upload'
  | 'vin'
  | 'warranty'
  | 'watching-people'
  | 'weight'
  | 'whatsapp'
  | 'window-tinting';

export const iconNames: readonly IconName[] = [
  '7days',
  'adaptive-cruise-control',
  'air-conditioning',
  'alloy-wheel',
  'ancap',
  'android-auto',
  'apple-car-play',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'automatic-transmission',
  'avatar',
  'awd',
  'battery-capacity',
  'bell-off',
  'bell-on',
  'bin',
  'body-type',
  'calendar',
  'calendar-with-tick',
  'call',
  'car-finance-application',
  'car-front',
  'caret-down',
  'caret-left',
  'caret-right',
  'caret-right-filters',
  'caret-up',
  'check',
  'circle-cross-filled',
  'circle-tick-filled',
  'clock',
  'close',
  'close-doors',
  'colour',
  'coupon',
  'cylinders',
  'delivery-car',
  'direction-gps',
  'document',
  'door',
  'download',
  'drive-type',
  'edit',
  'electric-motor',
  'electric-range',
  'email',
  'emissions',
  'energy-consumption',
  'engine',
  'engine-power',
  'expand',
  'exterior',
  'features',
  'file',
  'filter',
  'form',
  'free-delivery',
  'fuel-consumption',
  'fuel-tank-capacity',
  'gallery',
  'heads-up-display',
  'headset',
  'heart',
  'heart-filled',
  'heated-seat',
  'hide',
  'image',
  'imperfections',
  'info-circle',
  'info-circle-empty',
  'interior',
  'keyless-entry',
  'length',
  'location-pin',
  'make-model',
  'manual-transmission',
  'mechanical',
  'menu',
  'message',
  'meter',
  'number-of-keys',
  'open-bonnet',
  'open-doors',
  'pdf',
  'pencil',
  'petrol',
  'phone',
  'play',
  'price',
  'push-start',
  'question-mark-empty',
  'rear-parking-camera',
  'rear-parking-sensor',
  'registration-number',
  'safety',
  'search',
  'seats',
  'share',
  'show',
  'sign-out',
  'sort',
  'spanner',
  'sparkle',
  'sunroof',
  'thumbs-up',
  'tick',
  'tow-cap-braked',
  'towing',
  'transparent-rates',
  'trash',
  'upload',
  'vin',
  'warranty',
  'watching-people',
  'weight',
  'whatsapp',
  'window-tinting',
];
